import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({ name: 'timeDifference' })
export class TimeDifferencePipe implements PipeTransform {
  transform(from: string, to: string, unit: moment.unitOfTime.Diff = 'minutes'): number {
    return moment(to, 'HH:mm').diff(moment(from, 'HH:mm'), unit);
  }
}
